// src/components/GoldLoanPage.js
import React, { useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import { StateContext } from "../../contexts/StateContext";
import { getSinglePLData, savePersonalLoanDataBff } from "../../api/PupilApi";
import { getAllPersonalLoanDataBff } from "../../api/PupilApi"
import { useNavigate } from "react-router-dom";
import { updateApplicantData } from "../../api/AdminApi";
import toast from "react-hot-toast";

const PersonalLoan = () => {
  const navigate = useNavigate();
  const isLoggedIn = useContextSelector(StateContext, (state) => state.isLoggedIn);

  // form state
  const [formData, setFormData] = useState({
    fullName: "",
    dob: "",
    gender: "",
    maritalStatus: "",
    phone: "",
    email: "",
    address: "",
    pan: "",
    aadhaar: "",
    employmentType: "",
    company: "",
    designation: "",
    experience: "",
    income: "",
    otherIncome: "",
    existingEmi: "",
    bankAccount: "",
    loanAmount: "",
    tenure: "",
    purpose: "",
    interestRate: "",
    personalLoanStatus: "",
  });
  const [formUpdateData, setFormUpdateData] = useState({
    id: "",
    fullName: "",
    dob: "",
    gender: "",
    maritalStatus: "",
    phone: "",
    email: "",
    address: "",
    pan: "",
    aadhaar: "",
    employmentType: "",
    company: "",
    designation: "",
    experience: "",
    income: "",
    otherIncome: "",
    existingEmi: "",
    bankAccount: "",
    loanAmount: "",
    tenure: "",
    purpose: "",
    interestRate: "",
    penality: "",
    personalLoanStatus: "",
    pupilEmail: "",
  });
  const [userCardData, SetUserCardData] = useState({
    fullName: "",
    dob: "",
    gender: "",
    maritalStatus: "",
    phone: "",
    email: "",
    address: "",
    pan: "",
    aadhaar: "",
    employmentType: "",
    company: "",
    designation: "",
    experience: "",
    income: "",
    otherIncome: "",
    existingEmi: "",
    bankAccount: "",
    loanAmount: "",
    tenure: "",
    purpose: "",
    interestRate: "",
    penality: "",
    personalLoanStatus: "",
  });
  const [showModal, setShowModal] = useState(false);

  const [formErrors, setFormErrors] = useState({});
    const role = useContextSelector(StateContext, (state) => state.role);
  const [applicants, setApplicants] = useState({
    id:"",
    fullName: "",
    dob: "",
    gender: "",
    maritalStatus: "",
    phone: "",
    email: "",
    address: "",
    pan: "",
    aadhaar: "",
    employmentType: "",
    company: "",
    designation: "",
    experience: "",
    income: "",
    otherIncome: "",
    existingEmi: "",
    bankAccount: "",
    loanAmount: "",
    tenure: "",
    purpose: "",
    interestRate: "",
    penality: "",
    personalLoanStatus: "",
  });
  const [selectedApplicant, setSelectedApplicant] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(role);
    if (role === "ADMIN") {
      loadData();
    } else if (role === "PUPIL") {
      loadUserData();
    }
  }, [role]);

 const loadData = () => {
  setLoading(true);
  const currentYear = new Date().getFullYear();
  const startDate = new Date(`${currentYear}-01-01`);
  const endDate = new Date(`${currentYear}-12-31`);
  const formatDate = (date) => date.toISOString().split("T")[0];

  getAllPersonalLoanDataBff(formatDate(startDate), formatDate(endDate), "personalLoan")
    .then((res) => {
      

      // flatten all personalLoanData arrays into a single list
let loanApplicants =
  res.data
    ?.filter((item) => Array.isArray(item.personalLoanData) && item.role !== "ADMIN")
    .flatMap((item) =>
      item.personalLoanData.map((loan) => ({
        ...loan,
        pupilEmail: item.pupilEmail, // add pupilEmail into each loan record
      }))
    )
    .filter((loan) => loan != null) || [];

         

      console.log("Merged Loan Applicants:", loanApplicants);
      setApplicants(loanApplicants);
    })
    .catch((err) => {
      toast.error("Failed to load applicants data");
      console.error(err);
    })
    .finally(() => setLoading(false));
};



  const loadUserData = () => {
    setLoading(true);
    getSinglePLData()
      .then((res) => {
        const data = res.data.data.personalLoanData;
        if (data) {
          SetUserCardData((prev) => ({ ...prev, ...data }));
        }
      })
      .catch((err) => {
        // toast.error("Failed to load applicants data");
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  // input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    // auto format PAN to uppercase
    if (name === "pan") {
      formattedValue = value.toUpperCase();
    }

    setFormData((prev) => ({ ...prev, [name]: formattedValue }));
    setFormErrors((prev) => ({ ...prev, [name]: "" })); // clear error when typing
  };

  // validation function
  const validateForm = () => {
    let errors = {};

    if (!formData.fullName.trim()) errors.fullName = "Full Name is required";
    if (!formData.dob) errors.dob = "Date of Birth is required";
    if (!formData.gender) errors.gender = "Please select gender";
    if (!formData.maritalStatus) errors.maritalStatus = "Please select marital status";

    if (!formData.phone) {
      errors.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      errors.phone = "Enter a valid 10-digit phone number";
    }

    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    if (!formData.address.trim()) errors.address = "Address is required";

    // ✅ PAN Validation: must be 10 characters
    if (!formData.pan) {
      errors.pan = "PAN is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan)) {
      errors.pan = "Enter a valid 10-character PAN (e.g., ABCDE1234F)";
    }

    // ✅ Aadhaar Validation: must be 12 digits
    if (!formData.aadhaar) {
      errors.aadhaar = "Aadhaar is required";
    } else if (!/^\d{12}$/.test(formData.aadhaar)) {
      errors.aadhaar = "Enter a valid 12-digit Aadhaar number";
    }

    if (!formData.employmentType) errors.employmentType = "Employment type is required";
    if (!formData.company.trim()) errors.company = "Company/Business Name is required";
    if (!formData.designation.trim()) errors.designation = "Designation is required";
    if (!formData.experience) errors.experience = "Experience is required";
    if (!formData.income) errors.income = "Monthly income is required";

    if (!formData.bankAccount) {
      errors.bankAccount = "Bank account number is required";
    } else if (!/^\d{9,18}$/.test(formData.bankAccount)) {
      errors.bankAccount = "Enter a valid bank account number (9–18 digits)";
    }

    if (!formData.loanAmount) errors.loanAmount = "Loan amount is required";
    if (!formData.tenure) errors.tenure = "Tenure is required";
    if (!formData.purpose) errors.purpose = "Please select purpose";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // submit handler
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please correct the errors in the form");
      return;
    } else {
      toast.success("all the fields are succefully entered");
    }
    // isLoggedIn = true;
    if (isLoggedIn) {
      savePersonalLoanDataBff(formData)
        .then((res) => {
          toast.success(res.message || "Application submitted successfully!");
          navigate("/personalLoanSucess");
        })
        .catch((error) => {
          toast.error(error.message || "Sorry! Something went wrong. Please try again!");
          console.error(error);
        });
    } else {
      navigate("/signup");
    }
  };

  const handleEdit = (rowData) => {
    setShowModal(true);
    setFormUpdateData((prev) => {
      const updatedData = { ...prev };
      Object.keys(updatedData).forEach((key) => {
        if (rowData.hasOwnProperty(key)) {
          updatedData[key] = rowData[key];
        }
      });
      return updatedData;
    });
  };

  const updateApplicant = (formUpdateData) => {
    alert("updateApplicant"+JSON.stringify(formUpdateData));
    updateApplicantData(formUpdateData);
  }

  // const handleAction = (app, action) => {
  //   if (action === "APPROVE") {
  //     requestChangeStatus(app.email, action);
  //     toast.success(`Application for ${app.fullName} approved ✅`);
  //     loadData();
  //   } else if (action === "REJECT") {
  //     requestChangeStatus(app.email, action);
  //     toast.error(`Application for ${app.fullName} rejected ❌`);
  //     loadData();
  //   }
  //   console.log(`Action: ${action}`, app);

  //   // TODO: Call backend API here if needed
  //   // e.g. updatePersonalLoanStatus(app.id, action)
  // };

  // helper to show error
  const renderError = (field) =>
    formErrors[field] && <p className="text-red-500 text-sm">{formErrors[field]}</p>;

  if (role === "ADMIN") {
    return (
      <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
        <table className="w-full border-collapse text-sm text-gray-700">
          <thead className="bg-gray-100 text-gray-800 text-sm uppercase tracking-wide">
            <tr>
              <th className="border border-gray-200 px-4 py-3 text-left">Edit</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Full Name</th>
              <th className="border border-gray-200 px-4 py-3 text-left">DOB</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Gender</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Marital Status</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Phone</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Address</th>
              <th className="border border-gray-200 px-4 py-3 text-left">PAN</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Aadhaar</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Employment Type</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Employer Name</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Annual Income</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Loan Amount</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Loan Tenure</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Purpose</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Interest Rate</th>
               <th className="border border-gray-200 px-4 py-3 text-left">Penality</th>
              <th className="border border-gray-200 px-4 py-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {applicants.length > 0 ? (
              applicants.map((app, idx) => (
                <tr
                  key={idx}
                  onClick={() => setSelectedApplicant(app)} // click row → open modal
                  className={`cursor-pointer ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-indigo-50 transition-colors`}
                >
                  <td
                    className="border border-gray-200 px-4 py-2 text-center"
                    onClick={(e) => e.stopPropagation()} // stop row click
                  >
                    <button
                      onClick={() => handleEdit(app)}
                      className="px-3 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                      Edit
                    </button>
                  </td>
                  <td className="border border-gray-200 px-4 py-2 font-medium">{app.fullName}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.dob}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.gender}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.maritalStatus}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.phone}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.address}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.pan}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.aadhaar}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.employmentType}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.company}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.income}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.loanAmount}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.tenure}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.purpose}</td>

                  <td className="border border-gray-200 px-4 py-2">{app.interestRate}</td>
                  <td className="border border-gray-200 px-4 py-2">{app.penality}</td>
                  <td className="border border-gray-200 px-4 py-2">
                    <span
                      className={`font-semibold ${app.personalLoanStatus === "APPROVED"
                        ? "text-green-600"
                        : app.personalLoanStatus === "REJECTED"
                          ? "text-red-600"
                          : "text-gray-600"
                        }`}
                    >
                      {app.personalLoanStatus || "N/A"}
                    </span>
                  </td>
                  {/* <td
                    className="border border-gray-200 px-4 py-2 text-center space-x-2"
                    onClick={(e) => e.stopPropagation()} // stop row click
                  >
                    {app.personalLoanStatus === "pending" ||
                      app.personalLoanStatus === "PENDING" ? (
                      <div>
                        <button
                          onClick={() => handleAction(app, "APPROVE")}
                          className="px-3 py-1 bg-green-600 text-white rounded-lg hover:bg-green-700"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => handleAction(app, "REJECT")}
                          className="px-3 py-1 bg-red-600 text-white rounded-lg hover:bg-red-700"
                        >
                          Reject
                        </button>
                      </div>
                    ) : null}
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="17"
                  className="text-center px-4 py-6 text-gray-500 italic bg-gray-50"
                >
                  No applications found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Modal Popup */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl shadow-lg w-[600px] relative max-h-[90vh] overflow-y-auto">
              <h2 className="text-xl font-bold mb-4">Edit Applicant Details</h2>

              <div className="space-y-3 text-sm">
                {/* Full Name */}
                <div>
                  <label className="block font-semibold">Full Name</label>
                  <input
                    type="text"
                    value={formUpdateData.fullName}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, fullName: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* DOB */}
                <div>
                  <label className="block font-semibold">DOB</label>
                  <input
                    type="date"
                    value={formUpdateData.dob}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, dob: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Gender */}
                <div>
                  <label className="block font-semibold">Gender</label>
                  <select
                    value={formUpdateData.gender}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, gender: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* Marital Status */}
                <div>
                  <label className="block font-semibold">Marital Status</label>
                  <select
                    value={formUpdateData.maritalStatus}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, maritalStatus: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* Phone */}
                <div>
                  <label className="block font-semibold">Phone</label>
                  <input
                    type="text"
                    value={formUpdateData.phone}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, phone: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>



                {/* Address */}
                <div>
                  <label className="block font-semibold">Address</label>
                  <textarea
                    value={formUpdateData.address}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, address: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* PAN */}
                <div>
                  <label className="block font-semibold">PAN</label>
                  <input
                    type="text"
                    value={formUpdateData.pan}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, pan: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2 uppercase"
                    maxLength={10}
                  />
                </div>

                {/* Aadhaar */}
                <div>
                  <label className="block font-semibold">Aadhaar</label>
                  <input
                    type="text"
                    value={formUpdateData.aadhaar}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, aadhaar: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                    maxLength={12}
                  />
                </div>

                {/* Employment Type */}
                <div>
                  <label className="block font-semibold">Employment Type</label>
                  <input
                    type="text"
                    value={formUpdateData.employmentType}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, employmentType: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Employer Name */}
                <div>
                  <label className="block font-semibold">Employer Name</label>
                  <input
                    type="text"
                    value={formUpdateData.company}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, company: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Annual Income */}
                <div>
                  <label className="block font-semibold">Annual Income</label>
                  <input
                    type="number"
                    value={formUpdateData.income}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, income: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Loan Amount */}
                <div>
                  <label className="block font-semibold">Loan Amount</label>
                  <input
                    type="number"
                    value={formUpdateData.loanAmount}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, loanAmount: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Loan Tenure */}
                <div>
                  <label className="block font-semibold">Loan Tenure</label>
                  <input
                    type="number"
                    value={formUpdateData.tenure}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, tenure: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Purpose */}
                <div>
                  <label className="block font-semibold">Purpose</label>
                  <input
                    type="string"
                    step="0.01"
                    value={formUpdateData.purpose}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, purpose: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                <div>
                  <label className="block font-semibold">Interest Rate</label>
                  <input
                    type="string"
                    step="0.01"
                    value={formUpdateData.interestRate}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, interestRate: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                <div>
                  <label className="block font-semibold">Penality</label>
                  <input
                    type="string"
                    step="0.01"
                    value={formUpdateData.penality}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, penality: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>


                {/* Status */}
                <div>
                  <label className="block font-semibold">Status</label>
                  <select
                    value={formUpdateData.personalLoanStatus}
                    onChange={(e) =>
                      setFormUpdateData({ ...formUpdateData, personalLoanStatus: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    // 🔹 Call API to update applicant data here
                    updateApplicant(formUpdateData);
                    console.log("Updated Data:", formUpdateData);
                    setShowModal(false);
                  }}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                >
                  Update
                </button>
              </div>

              {/* Close (X) */}
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-2 right-2 px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600"
              >
                ✕
              </button>
            </div>
          </div>
        )}

      </div>

    );

  } else if(!isLoggedIn){ return(<div>
         <div className="flex items-center justify-center min-h-[60vh] bg-gray-50">
      <div className="bg-white shadow-md rounded-xl p-8 text-center max-w-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-3">
          Please Login
        </h2>
        <p className="text-gray-600 mb-6">
          You need to log in to apply for a loan and access your application details.
        </p>
        <button
          onClick={() => navigate("/signin")}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Go to Login
        </button>
      </div>
    </div>
  </div>)}
  else {
    return (
      <>
          <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-2xl">
            <h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Personal Loan Application
            </h1>
            <form onSubmit={handleSubmit} className="space-y-8">

              {/* Personal Details */}
              <div>
                <h2 className="text-lg font-semibold mb-3 text-gray-700">Personal Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Full Name */}
                  <div>
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Full Name"
                      value={formData.fullName}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("fullName")}
                  </div>

                  {/* DOB */}
                  <div>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("dob")}
                  </div>

                  {/* Gender */}
                  <div>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    >
                      <option value="">Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    {renderError("gender")}
                  </div>

                  {/* Marital Status */}
                  <div>
                    <select
                      name="maritalStatus"
                      value={formData.maritalStatus}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    >
                      <option value="">Marital Status</option>
                      <option value="Single">Single</option>
                      <option value="Married">Married</option>
                    </select>
                    {renderError("maritalStatus")}
                  </div>

                  {/* Phone */}
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("phone")}
                  </div>

                  {/* Email */}
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("email")}
                  </div>

                  {/* Address */}
                  <div className="col-span-2">
                    <input
                      type="text"
                      name="address"
                      placeholder="Address"
                      value={formData.address}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("address")}
                  </div>

                  {/* PAN */}
                  <div>
                    <input
                      type="text"
                      name="pan"
                      placeholder="PAN Number"
                      value={formData.pan}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("pan")}
                  </div>

                  {/* Aadhaar */}
                  <div>
                    <input
                      type="text"
                      name="aadhaar"
                      placeholder="Aadhaar Number"
                      value={formData.aadhaar}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("aadhaar")}
                  </div>
                </div>
              </div>

              {/* Employment Details */}
              <div>
                <h2 className="text-lg font-semibold mb-3 text-gray-700">Employment Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <select
                      name="employmentType"
                      value={formData.employmentType}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    >
                      <option value="">Employment Type</option>
                      <option value="Salaried">Salaried</option>
                      <option value="Self-Employed">Self-Employed</option>
                      <option value="Business">Business</option>
                    </select>
                    {renderError("employmentType")}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="company"
                      placeholder="Company / Business Name"
                      value={formData.company}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("company")}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="designation"
                      placeholder="Designation"
                      value={formData.designation}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("designation")}
                  </div>

                  <div>
                    <input
                      type="number"
                      name="experience"
                      placeholder="Years of Experience"
                      value={formData.experience}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("experience")}
                  </div>
                </div>
              </div>

              {/* Income Details */}
              <div>
                <h2 className="text-lg font-semibold mb-3 text-gray-700">Income Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="number"
                      name="income"
                      placeholder="Monthly Income"
                      value={formData.income}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("income")}
                  </div>

                  <div>
                    <input
                      type="number"
                      name="otherIncome"
                      placeholder="Other Income (Optional)"
                      value={formData.otherIncome}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                  </div>

                  <div>
                    <input
                      type="number"
                      name="existingEmi"
                      placeholder="Existing EMI (if any)"
                      value={formData.existingEmi}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                  </div>

                  <div>
                    <input
                      type="text"
                      name="bankAccount"
                      placeholder="Bank Account Number"
                      value={formData.bankAccount}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("bankAccount")}
                  </div>
                </div>
              </div>

              {/* Loan Details */}
              <div>
                <h2 className="text-lg font-semibold mb-3 text-gray-700">Loan Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="number"
                      name="loanAmount"
                      placeholder="Required Loan Amount"
                      value={formData.loanAmount}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("loanAmount")}
                  </div>

                  <div>
                    <input
                      type="number"
                      name="tenure"
                      placeholder="Loan Tenure (in months)"
                      value={formData.tenure}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    />
                    {renderError("tenure")}
                  </div>

                  <div className="col-span-2">
                    <select
                      name="purpose"
                      value={formData.purpose}
                      onChange={handleChange}
                      className="p-2 border rounded-lg w-full"
                    >
                      <option value="">Select Purpose</option>
                      <option value="Education">Education</option>
                      <option value="Medical">Medical</option>
                      <option value="Marriage">Marriage</option>
                      <option value="Home Renovation">Home Renovation</option>
                      <option value="Travel">Travel</option>
                      <option value="Other">Other</option>
                    </select>
                    {renderError("purpose")}
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div className="flex justify-center">
                <button
                  type="submit"
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700"
                >
                  Submit Application
                </button>
              </div>
            </form>
          </div>
      </>
    )
  };
  // Admin



};

export default PersonalLoan;
